const SMALL_WIDTH = '440px';
const LARGE_WIDTH = '600px';
/**
 * Resolve the desktop dialog `maxWidth`: `small`/`large` map to the design
 * tokens, any other string is treated as a raw CSS width, and the default is
 * `large`.
 */
export function getDialogMaxWidth(width) {
    if (width === 'small') {
        return SMALL_WIDTH;
    }
    if (width && width !== 'large') {
        return width;
    }
    return LARGE_WIDTH;
}
